import _ from 'lodash';

/** Mapping variant with line height */
export const variantToLineHeightMapping = {
  hero: 56,
  h1: 40,
  h2: 32,
  h3: 28,
  h4: 24,
  h5: 20,
  h6: 16,
  p: 20,
  'p-bold': 20,
  'p-small': 16,
  'p-small-bold': 16,
  'p-large': 24,
  'p-large-bold': 24,
  'headline-large': 40,
  'page-title': 32,
  'modal-title': 28,
  'section-label': 24,
  'content-label': 24,
  'content-label-subhead': 20,
  'body-large': 24,
  'body-normal': 20,
  footnote: 18,
  caption: 18,
  overline: 18,
};

export type TooltipPosition = 'top' | 'bottom' | 'left' | 'right';

export type TooltipAlignment = 'center' | 'left' | 'right';

export interface TooltipConfig {
  /**
   * Text for the Tooltip
   */
  dataTooltipContent: string | React.ReactElement | React.ReactElement[];

  /**
   * Alignment of tooltip
   * @default 'center'
   */
  dataTooltipAlign?: TooltipAlignment;

  /**
   * Positon of tooltip
   * @default 'top'
   */
  dataTooltipPosition?: TooltipPosition;

  /**
   * Show tooltip only when ellipsis are added or else won't show tooltip.
   * When set to false, tooltip will be always shown on hover.
   * @default false
   */
  showTooltipOnlyOnEllipsis?: boolean;

  /**
   * To never show tooltip
   * @default false
   */
  disableTooltip?: boolean;
}

/**
 * Returns the tooltip configurations object which inlcudes 'data-tooltip-content', 'data-tooltip-align' and 'data-tooltip-position'.
 * If tooltipConfig parameter is not passed, it returns an empty object.
 * If the text is truncated with ellipsis then shows a tooltip with the content passed to Typography.
 * On top of that if tooltipConfig is passed then it takes priority over the default behavior of showing tooltip only when text is truncated.
 * @param content Content comes as the children from the Typography component
 * @param tooltipConfig Tooltip config
 * @param isEllipsisShown Is ellispsis shown or not
 */
export const getTooltipProps = (
  content: any,
  tooltipConfig?: TooltipConfig,
  isEllipsisShown?: boolean
) => {
  const {
    dataTooltipContent,
    dataTooltipAlign,
    dataTooltipPosition,
    showTooltipOnlyOnEllipsis,
    disableTooltip,
  } = tooltipConfig || {};
  let tooltipProps = {};

  let showTooltip = true;
  if (disableTooltip) {
    showTooltip = false;
    // When Neither tooltip config is passed and Ellipsis not present
  } else if (!tooltipConfig && !isEllipsisShown) {
    showTooltip = false;
    // When Tooltip config mentions to show tooltip only on Ellipsis and Ellipsis are not present
  } else if (tooltipConfig && showTooltipOnlyOnEllipsis && !isEllipsisShown) {
    showTooltip = false;
  }

  if (showTooltip) {
    tooltipProps = {
      'data-tooltip-content': dataTooltipContent ?? content,
      'data-tooltip-align': dataTooltipAlign ?? 'center',
      'data-tooltip-position': dataTooltipPosition ?? 'top',
    };
  }

  return tooltipProps;
};

export const getAriaProps = (role?: string) => {
  let ariaProps;
  if (!_.isEmpty(role)) {
    ariaProps = {
      role,
    };
  }

  return ariaProps;
};
